import { Route, Routes } from "react-router-dom";
import Layout from './components/groupComponent/layout';
import { Dashboard} from './route';
import Providers from "./components/contentApi/Providers";
import Login from "./page/auth/Login";
import ForgetPassword from "./page/auth/ForgetPassword";

import Dashboard1 from "./page/Dashboard1";


import IncidentIntegration from "./page/IncidentIntegration";
import IncidentIntegrationForm from "./components/baseComponent/IncidentIntegrationForm";
import StudentForm from "./components/baseComponent/StudentForm";
import Student from "./page/Student";
import CanteenForm from "./components/baseComponent/CanteenForm";
import Canteen from "./page/Canteen";
import Roleaccess from "./page/Roleaccess";
import ReloadForm from "./components/baseComponent/ReloadForm";
import Reload from "./page/Reload";



function App() {

  return (
    <>
      <Providers>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/admin" element={<Layout />}>
            <Route path="dashboard1" element={<Dashboard1 />} />
            <Route path="incidentintegration" element={<IncidentIntegration />} />
            <Route path="incidentintegrationform" element={<IncidentIntegrationForm />} />
            <Route path="studentform" element={<StudentForm />} />
            <Route path="student" element={<Student />} />
            <Route path="canteenform" element={<CanteenForm />} />
            <Route path="canteen" element={<Canteen />} />
            <Route path="roleaccess" element={<Roleaccess />} />
            <Route path="reloadform" element={<ReloadForm />} />
            <Route path="reload" element={<Reload />} />
            
          </Route>
          <Route path="/employee" element={<Layout />}>
            <Route path="dashboard1" element={<Dashboard1 />} />

          </Route>

          <Route path="/trainer" element={<Layout />}>
            <Route path="dashboard1" element={<Dashboard1 />} />
          </Route>
        </Routes>
      </Providers>
    </>
  );
}

export default App;
